import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function ChevronDownIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon
      viewBox="0 0 16 16"
      {...props}
      style={{
        ...props.style,
        strokeWidth: props.strokeWidth || 0.667,
        stroke: props.stroke || props.style?.stroke || Color.Body,
        fill: props.fill || props.style?.fill|| Color.Body
      }}
    >
      <path d="m2.414 5.036.003.003 5.35 5.225.234.228.233-.23 5.35-5.275.002-.001a.225.225 0 0 1 .328 0 .225.225 0 0 1 0 .328l-5.748 5.648-.002.002c-.096.097-.141.103-.164.103a.273.273 0 0 1-.18-.068L2.085 5.364a.225.225 0 0 1 0-.328.225.225 0 0 1 .33 0Z" />
    </MuiSvgIcon>
  );
}
export default ChevronDownIcon;
